export const formatApiError = (error, fallbackMessage = 'Request failed') => {
  const data = error?.response?.data;

  if (!data) {
    return error?.message || fallbackMessage;
  }

  if (typeof data === 'string') {
    return data;
  }

  if (data.detail) {
    return data.detail;
  }

  if (data.error) {
    return data.error;
  }

  const fieldErrors = Object.entries(data)
    .flatMap(([field, value]) => {
      const label = field.replace(/_/g, ' ');
      const messages = Array.isArray(value) ? value : [value];
      return messages.map((message) => `${label}: ${message}`);
    })
    .filter(Boolean);

  if (fieldErrors.length > 0) {
    return fieldErrors.join(' | ');
  }

  return fallbackMessage;
};
